import { HeadersOptionsType } from "@/types/ModuleOptionsType";
import { ParentsType } from "../../../wp/getParentPages";
import { UniversalHeader } from "../UniversalHeader/UniversalHeader";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { Post } from "@/wp/types/client";
import { ImageType, LinkType } from "@/types/baseTypes";
// import { ContentTag } from "@/components/ContentTag/ContentTag";
import { Headline } from "@/components/Headline/Headline";
import { MediaItemResponsive } from "@/components/MediaItem/MediaItemResponsive";
import { OptionsFactsheetsType } from "@/types/OptionType";
import { getFactsheetFromOptions } from "@/utils/getFactsheet";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
export interface MetalHeaderProps {
  post: Post<"metals">;
  headerOptions?: HeadersOptionsType["header_posts"]; // Reusing header_posts options or use undefined if not available
  parents: ParentsType;
  fallbackImg?: ImageType | false;
  factsheets: OptionsFactsheetsType;
}
/* jscpd:ignore-start */
export const MetalHeader = ({
  post,
  headerOptions,
  parents,
  fallbackImg,
  factsheets,
}: MetalHeaderProps) => {
  const header = post.acf.header_metal;
  const {
    // metal_name,
    title,
    subline,
    image_left,
    image_right,
    // link_extended,
    background_color_class,
    section_margin_class,
    headline_text_align_class,
    noble_info,
    seo_settings: { breadcrumb_title },
  } = header;

  const { breadcrumb_position } = headerOptions ?? {};

  const breadcrumbsJSX = (
    <div className="nav-oriented-breadcrumbs">
      <Breadcrumbs
        parents={parents}
        breadcrumbPositon={
          breadcrumb_position
            ? breadcrumb_position
            : "is-justify-content-flex-start"
        }
        breadcrumbTitle={breadcrumb_title}
      />
    </div>
  );

  const mediaJSX = (
    <MediaItemResponsive
      image_desktop={
        image_left ? image_left : fallbackImg ? fallbackImg : false
      }
      sizes="(max-width: 1023px) 100vw, 66vw"
      priority={true}
      className={`h-full`} // Defaulting to auto-height for split header style
    />
  );

  const contentJSX = (
    <>
      <Headline
        headline={title}
        headline_html_tag="h1-posts"
        extraClass={`is-flex is-flex-direction-column ${headline_text_align_class}`}
        // overline={metal_name}
        subline={subline}
        disableAnimation
      />
      {/* {noble_info?.excerpt && (
        <ContentTag extraClass="intro-text" content={noble_info.excerpt} />
      )} */}
    </>
  );

  // Convert link_extended to LinkType expected by UniversalHeader
  let link: LinkType | undefined;
  // if (link_extended?.link && typeof link_extended.link !== "string") {
  //   link = {
  //     url: link_extended.link.url,
  //     title: link_extended.link.title,
  //     target: link_extended.link.target as "_blank" | "",
  //     aria_label: link_extended.link.aria_label,
  //   };
  // }
  const factsheet = noble_info.factsheet;
  const pdf = factsheet ? getFactsheetFromOptions(factsheet, factsheets) : null;
  const { getLabel } = useGlobalContext();
  return (
    <UniversalHeader
      type="splitheader"
      mediaJSX={mediaJSX}
      contentJSX={contentJSX}
      breadcrumbsJSX={breadcrumbsJSX}
      background_color_class={background_color_class}
      section_margin_class={section_margin_class}
      image_small={image_right}
      link={
        link || pdf
          ? {
              title: pdf?.file.title ?? pdf?.file.filename ?? "",
              url: pdf?.file.url ?? "",
              target: "_blank",
              type: "download",
              aria_label: getLabel("aria_label_factsheet_btn").replace(
                "$title",
                pdf?.name || "",
              ),
            }
          : undefined
      }
    />
  );
};
/* jscpd:ignore-end */
